import React, { useMemo } from 'react';
import { ApolloProvider } from '@apollo/react-hooks';
import { ApolloLink, ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { type AuthOptions, createAuthLink } from 'aws-appsync-auth-link';
import { GQL } from '#/config/consts';
import { useAuth } from 'react-oidc-context';

const url = GQL.url;
const region = GQL.region;

const AwsApolloProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { user } = useAuth();
  const jwt = user?.id_token;

  console.log('auth', user);

  const client = useMemo(() => {
    if (!jwt) {
      return;
    }

    const link = ApolloLink.from([
      createAuthLink({
        url,
        region,
        auth: {
          type: 'AMAZON_COGNITO_USER_POOLS',
          jwtToken: jwt,
        },
      }),
      createHttpLink({
        uri: url,
      }),
    ]);

    return new ApolloClient({
      link,
      defaultOptions: {
        // caching disabled
        query: {
          fetchPolicy: 'no-cache',
        },
        watchQuery: {
          fetchPolicy: 'no-cache',
        },
      },
      cache: new InMemoryCache({
        typePolicies: {
          Asset: {
            keyFields: false,
          },
        },
      }),
    });
  }, [jwt]);

  if (!client) {
    return null;
  }

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};

export default React.memo(AwsApolloProvider);
